import { Pipe, PipeTransform } from "@angular/core";

/**
 * Takes minutes and converts it to readable format (5h 38m)
 * @Input minutes
 * @Output string
 */

@Pipe({
  name: "otDurationPipe4",
})
export class OtDurationPipe4 implements PipeTransform {
  transform(value: number): string {
    const totalMinutes = Math.round(value);
    if (totalMinutes < 1) return "-";
    
    const hours: number = Math.floor(totalMinutes / 60);
    const minutes: number = totalMinutes % 60;

    const hourStr = hours ? `${hours}h ` : "";
    const minuteStr = minutes || hours ? `${minutes}m` : "";

    return `${hourStr}${minuteStr}`.trim();


  }
}
